import api from "@/services/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { ListParams } from "../types/common";
import { SavePpdbPayload } from "../types/ppdbType";

export const getPpdbList = createAsyncThunk("/ppdb/list", async (params: ListParams = {}) => {
  const query = new URLSearchParams();
  if (params.page) query.set("page", String(params.page));
  if (params.limit) query.set("limit", String(params.limit));
  if (params.keyword) query.set("keyword", params.keyword);
  const response = (await api.get(`/ppdb?${query.toString()}`)).data;
  return response;
});

export const savePpdb = createAsyncThunk("/ppdb/save", async (payload: SavePpdbPayload) => {
  const response = (await api.post("/ppdb/action", payload)).data;
  return response;
});

export const deletePpdb = createAsyncThunk("/ppdb/delete", async (id: number) => {
  const response = (await api.get(`/ppdb/delete/${id}`)).data;
  return response;
});
